document.addEventListener("DOMContentLoaded", function () {
  const stickyElement = document.querySelector(".product__column-sticky");
  const headerElement = document.querySelector(".section-header");

  function updateStickyTop() {
    if (!stickyElement || !headerElement) return; // Ensure elements are present

    const headerHeight = headerElement.offsetHeight; // Get the height of .section-header
    const scrolledPastHeader = document.body.classList.contains("scrolled-past-header");

    if (scrolledPastHeader) {
      stickyElement.style.top = `calc(3rem + ${headerHeight}px)`; // Add extra height
    } else {
      stickyElement.style.top = "3rem"; // Default top value
    }
  }

  // Debounce function to limit how often updateStickyTop is called
  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // Initial update
  updateStickyTop();

  // Debounced event listener for scroll
  window.addEventListener("scroll", debounce(updateStickyTop, 50));

  // Event listener for window resize
  window.addEventListener("resize", updateStickyTop);
});


class VariantAccordion extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.initFunction();
  }
  
  initFunction() {
    // Select all accordions within the custom element
    let accordions = this.querySelectorAll('.accordian');

    // Check if there are any accordions and iterate over them
    if (accordions.length) {
      accordions.forEach((element) => {
        let icon = element.querySelector('.custom-icon-arrow');
        let answer = element.querySelector('.answer');
        let question = element.querySelector('.question');

        // Add click event listener to each accordion
        element.addEventListener('click', () => {
          if (question.classList.contains('open')) {
            question.classList.remove('open');
            answer.style.maxHeight = null; // Collapse the answer
          } else {
            question.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px'; // Expand the answer
          }
        });
      });
    }
  }
}
// // Define the custom element
customElements.define('variant-accordion', VariantAccordion);

let accordian = document.querySelectorAll('.myaccordian');
accordian.length && accordian.forEach((element)=>{
    let icon = element.querySelector('.custom-icon-arrow');
    let answer = element.querySelector('.answer');
    let question = element.querySelector('.question');
    element.addEventListener('click',()=>{
        if (question.classList.contains('open')){
            question.classList.remove('open');
            answer.style.maxHeight = null;
        }else{
            question.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
        }
    })
})


